import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useWhiteLabelStore } from '@/stores/whiteLabelStore';
import { useSidebarStore } from '@/stores/sidebarStore';

export const AppLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isCollapsed } = useSidebarStore();
  const location = useLocation();
  const { isLoaded, loadSettings } = useWhiteLabelStore();
  
  // Check if current route is flow builder
  const isFlowBuilder = location.pathname.includes('/flows/new') || 
                        location.pathname.includes('/flows/') && location.pathname.includes('/edit');

  useEffect(() => {
    console.log('AppLayout mounted');
    console.log('Sidebar open:', isSidebarOpen);
  }, [isSidebarOpen]);

  // Load white-label settings on mount
  useEffect(() => {
    if (!isLoaded) {
      loadSettings();
    }
  }, [isLoaded, loadSettings]);

  const toggleSidebar = () => {
    console.log('Toggle sidebar');
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    console.log('Close sidebar');
    setIsSidebarOpen(false);
  };

  return (
    <div 
      className="min-h-screen relative"
      style={{ backgroundColor: '#F6F6F8' }}
    >
      {/* Sidebar - sempre visível em desktop */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      
      {/* Main content area */}
      <div className={clsx(
        'flex flex-col min-h-screen transition-all duration-300',
        isCollapsed ? 'lg:ml-[72px]' : 'lg:ml-64'
      )}>
        {/* Header - sempre visível */}
        <Header onMenuClick={toggleSidebar} />
        
        {/* Main content - remove padding for flow builder */}
        <main className={isFlowBuilder ? 'flex-1' : 'flex-1'}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
